var collapsible_list_pair_rtlignore_default = {
  "container": "gQJn3",
  "title": "u6cbt",
  "viewerContainer": "_9UiA8",
  "titleContainer": "dFhf-",
  "content": "_6Pkt6",
  "expandIcon": "VOBSt",
  "dndIcon": "lWeyZ",
  "RTL": "OEpr8",
  "LTR": "K1j2K",
  "itemContainer": "BCM29",
  "itemContainerViewer": "r4Jzf",
  "mouseDown": "vsusp",
  "innerEditor": "VW7F-",
  "item": "FJaXb",
  "floatingAddPluginMenuWrapper": "UVc-k"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
